/**
 * Private modules
 */
const {
  alias,
  createQueryComponent,
  customerId,
  isSelected,
  objectId,
  objectIds,
  parentRootId,
  reason,
  systemGameTypeId,
} = require('../.private').components;

/**
 * Scopes
 */
const {
  CUSTOMER_RUNNER_CONTRACTS_INPUT_BY_SYSTEM_GAME_TYPE_ID,
  DEFAULT,
} = require('../../scopes');

module.exports = {
  cloneCustomerRunnerContractByParentRootId: {
    properties: {
      params: {
        properties: {
          customerId,
          parentRootId,
        },
        required: [
          'customerId',
          'parentRootId',
        ],
        type: 'object',
      },
    },
    required: ['params'],
    type: 'object',
  },
  createCustomerRunnerContractBySystemGameTypeId: {
    properties: {
      params: {
        properties: {
          customerId,
          systemGameTypeId,
        },
        required: [
          'customerId',
          'systemGameTypeId',
        ],
        type: 'object',
      },
    },
    required: ['params'],
    type: 'object',
  },
  deleteCustomerRunnerContractsBySystemGameTypeId: {
    properties: {
      body: {
        properties: {
          objectIds,
          reason,
        },
        required: [
          'objectIds',
          'reason',
        ],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameTypeId,
        },
        required: [
          'customerId',
          'systemGameTypeId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  getCustomerRunnerContractsBySystemGameTypeId: {
    properties: {
      params: {
        properties: {
          customerId,
          systemGameTypeId,
        },
        required: [
          'customerId',
          'systemGameTypeId',
        ],
        type: 'object',
      },
      query: createQueryComponent([
        CUSTOMER_RUNNER_CONTRACTS_INPUT_BY_SYSTEM_GAME_TYPE_ID,
        DEFAULT,
      ]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  updateCustomerRunnerContractById: {
    properties: {
      body: {
        properties: {
          alias,
          isSelected,
        },
        required: [
          'alias',
          'isSelected',
        ],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          objectId,
        },
        required: [
          'customerId',
          'objectId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
};
